/**
 * @file 产品优势
 * @author
 */

import React from 'react';
import advantage1 from './imgs/advantage_1.png';
import advantage2 from './imgs/advantage_2.png';
import advantage3 from './imgs/advantage_3.png';
import advantage4 from './imgs/advantage_4.png';
import AuthButton from './authButton';

interface Props {
    title: string;
}
export default function Advantage(props: Props) {
    const data = [
        {
            img: advantage1,
            title: '杜绝恶意标记',
            content: '官方号码标识，增强权威背书'
        },
        {
            img: advantage2,
            title: '建立用户信任',
            content: '屏蔽错误信息，提升服务质量'
        },
        {
            img: advantage3,
            title: '提升号码曝光',
            content: '亿级用户流量，更多潜客搜索'
        },
        {
            img: advantage4,
            title: '树立企业形象',
            content: '全新升级卡片，实现品牌差异化'
        }
    ];
    return (
        <div className="advantage">
            <p className="common-title title">{props.title}</p>
            <div className="frame-card clear-float">
                {
                    data.map((item, index) => {
                        return (<div
                            className="card-item"
                            key={item.title + index}
                        >
                            <img className="card-item-img" src={item.img}/>
                            <h2>{item.title}</h2>
                            <p>{item.content}</p>
                        </div>);
                    })
                }
            </div>
            <AuthButton {...props} name="了解更多优势"/>
        </div>
    );
}
